export default "__VITE_ASSET__Blx0T9E3__"